import React, { useEffect, useRef } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Topbar from '../../../shared/components/Layout/Topbar';
import AccountSidebar from './AccountSidebar';
import { useAuthContext } from '../../auth/data/context/AuthContext';
import '../../settings/layout/SettingsLayout.css';
import '../../../shared/components/Layout/styles/LayoutStyles.css';

const AccountLayout: React.FC = () => {
  const { state, fetchProfile } = useAuthContext();
  const token = state.token || localStorage.getItem('iqadmin_token');
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (token && !state.user && !state.isProfileLoading && !hasFetchedRef.current) {
      hasFetchedRef.current = true;
      fetchProfile();
    }
  }, [token, state.user, state.isProfileLoading, fetchProfile]);

  if (!token) {
    return <Navigate to="/" replace />;
  }
  
  const profile = state.user;
  const userName = (profile as any)?.admin_username || (profile as any)?.full_name || profile?.company_name || 'Institute';
  const userEmail = profile?.email_address || state.email || '';

  return (
    <div className="dashboard-layout">
      <Topbar userName={userName} userEmail={userEmail} />
      <div className="bottom-container">
        <AccountSidebar />
        <main className="dashboard-content settings-main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AccountLayout;
